export type OwnershipState = {
  [key: number]: {
    color: string;
    title: string;
    state: boolean;
    id: number;
  };
};

export enum BasikFeatureLayer {
  Basik = 'basik',
  Ownerships = 'ownerships',
  Rdtr = 'rdtr',
  Price = 'price',
  Heatmap = 'heatmap',
  Btn = 'btn',
}

export type LayersEnableMap = {
  [BasikFeatureLayer.Basik]: boolean;
  [BasikFeatureLayer.Rdtr]: boolean;
  [BasikFeatureLayer.Price]: boolean;
  [BasikFeatureLayer.Ownerships]: boolean;
  [BasikFeatureLayer.Heatmap]: boolean,
  [BasikFeatureLayer.Btn]: boolean,
};
